<div class="card mb-3 pf-card mlp-sport-format d-none d-md-block">
    <div class="card-header">
        <h2 class="sg-heading__h5 mb-0">
            <mlp-ng-icon name="{{
                    lowercase(venueService.pitchData?.data.attributes.sport)
                }}"></mlp-ng-icon>
            {{
            venueService.pitchData?.data.attributes.sport
            | sportToPitchCourtText
            : venueService.pitchData?.data.attributes.sport
            : venueService.venueData
            }}
        </h2>
    </div>
    <div class="card-body">
        <ul class="list-inline">
            <li
                class="list-inline-item mb-1"
                *ngFor="let pitch of pitchesWithSameSport"
            >
                <a
                    class="sg-link__btn"
                    [routerLink]="[pitch.links.weblink]"
                    [routerLinkActive]="['-active']"
                    (click)="searchListLinkService.setPreviouslyViewed(false)"
                    [ngClass]="{
                        active:
                            isVenueHomepage(pitchesWithSameSport) &&
                            pitch.attributes.format ==
                                venueService.venueData.included[0].attributes
                                    .format
                    }"
                >
                    {{ pitch | sportFormatSurfaceText }}
                </a>
            </li>
        </ul>
        <div
            class="mt-4"
            *ngIf="
                venueService.pitchData?.data.attributes.facilities.length > 0
            "
        >
            <h5 class="sg-heading__h6">Facilities</h5>
            <ul class="list-inline font body3 mb-0">
                <li
                    class="list-inline-item"
                    *ngFor="
                        let facility of venueService.pitchData?.data.attributes
                            .facilities
                    "
                >
                    <mlp-ng-icon name="check-1"></mlp-ng-icon>
                    {{ facility }}
                </li>
            </ul>
        </div>
    </div>
</div>
<div
    *ngIf="venueService.pitchData?.data.attributes.mlp"
    class="card pf-card mb-3"
>
    <div class="card-header">
        <h2 class="sg-heading__h5 mb-0">
            <mlp-ng-icon name="style-one-pin"></mlp-ng-icon>
            Address
        </h2>
    </div>
    <div class="card-body">
        <p>
            {{ venueService.venueData?.data.attributes.name }} <br />
            {{ venueService.venueData?.data.attributes.address1 }}<br />
            {{ venueService.venueData?.data.attributes.address2 }}<br />
            {{ venueService.venueData?.data.attributes.postcode }}<br />
        </p>
        <mlp-ng-button-atom
            class="mt-2 mb-1 d-block"
            label="View On Map"
            fullWidth="1"
            btnSize="medium"
            btnStyle="tertiary"
            (click)="viewMap()"
        ></mlp-ng-button-atom>
        <div *ngIf="
                venueService.pitchData?.included[0] &&
                venueService.pitchData?.included[0].attributes.show_phone
            ">
            <mlp-ng-button-atom
                class="d-lg-none"
                label="Reveal Phone"
                fullWidth="1"
                btnSize="medium"
                btnStyle="tertiary"
                *ngIf="isPhoneNumberHidden"
                (click)="revealPhoneNumber()"
            ></mlp-ng-button-atom>
            <mlp-ng-button-atom
                class="d-none d-lg-block"
                label="Reveal Phone Number"
                fullWidth="1"
                btnSize="medium"
                btnStyle="tertiary"
                *ngIf="isPhoneNumberHidden"
                (click)="revealPhoneNumber()"
            ></mlp-ng-button-atom>
            <div *ngIf="!isPhoneNumberHidden">
                <a
                    href="tel: {{
                        venueService.pitchData?.included[0].attributes
                            .contact_number
                    }}"
                    class="sg-link__btn -active phone_number d-block text-center"
                >
                    {{
                    venueService.pitchData?.included[0].attributes
                    .contact_number
                    }}
                </a>
            </div>
        </div>
    </div>
</div>
<div id="mlp-enquiry"></div>


<div
    class="mb-3"
    *ngIf="venueService?.pitchData?.data?.attributes?.widgetUrl"
>

    <mlp-ng-button-atom
        class="d-lg-block"
        [label]="venueService.pitchData?.data.attributes.onlineBlockBooking ? 'Make a block booking' : 'Make a booking'"
        fullWidth="1"
        btnSize="medium"
        btnStyle="primary"
        (click)="openWidget(venueService.pitchData?.data.attributes.widgetUrl)"
    ></mlp-ng-button-atom>

</div>


<div
    class="card mb-3 pf-card card-similar"
    *ngIf="similarPitchData.length > 0"
>
    <div class="card-header">
        <h2 class="sg-heading__h6 mb-0">
            <mlp-ng-icon
                name="maps"
                class="mr-1"
            ></mlp-ng-icon>
            <ng-container *ngIf="!venueService.pitchData?.data.attributes.mlp">
                Book Online at our Nearby Partner Venues
            </ng-container>
            <ng-container *ngIf="venueService.pitchData?.data.attributes.mlp">
                Nearby
                {{
                venueService.pitchData?.data.attributes.sport
                | sportToPitchCourtText
                : "Venues"
                : venueService.venueData
                : true
                }}
            </ng-container>
        </h2>
    </div>
    <a
        class="card-body cursor pointer pb-0 pt-2"
        *ngFor="
            let similarData of similarPitchData | slice: 0:5;
            let last = last
        "
        [routerLink]="[similarData.pitch.links.weblink]"
        (click)="scrollToTheTop()"
    >
        <div class="row">
            <div class="col-4 col-md-12 col-lg-6 col-xl-4 p-2">
                <img
                    class="media-object rounded pf-card__img"
                    alt="{{ similarData.pitch.attributes.name }}"
                    src="{{ similarData.pitch.attributes.images.medium[0] }}"
                    width="100"
                    height="100"
                    imgService="w=170"
                />
            </div>
            <div class="col-8 col-md-12 col-lg-6 col-xl-8 p-2">
                <h6 class="body4">
                    {{ similarData.pitch.attributes.name }}
                </h6>
                <h6 class="body5 font-weight-normal border-bottom mb-1">
                    {{ similarData.venue.attributes.town }}
                </h6>
                <p class="mb-1 body5 font-weight-bold">
                    <span class="sg-color -secondary">
                        <mlp-ng-icon
                            name="style-two-pin-marker"
                            class="body1"
                        ></mlp-ng-icon>
                        {{ milesAway(similarData.venue) }}
                    </span>
                    <span class="ml-1 font-italic">
                        {{similarData.pitch.attributes.available_slots_total}} bookings available
                    </span>
                </p>
            </div>
        </div>
    </a>
</div>